<template>
	<div>
		<el-row>
			<el-col :span="8"><span>请支付:</span></el-col>
			<el-col :span="8" @click.native="payByAli()">
				<el-image :src="aliImg" style="max-width: 50px;float: left;">
				</el-image>
			</el-col>
			<el-col :span="8" @click.native="payByWX()">
				<el-image :src="wxImg" style="max-width: 50px;float: left;">
				</el-image>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import pay from '../../apifunction/OnlinePay.js'
	import ordercus from '../../apifunction/OrderCus.js'
	export default {
		created() {
			this.IsPaySuccess()
		},
		data() {
			return {
				aliImg: '/img/PayImg/ali.png',
				wxImg: '/img/PayImg/wx.png',
				cusent: this.incusent,
				Amount: this.inAmount,
				OrderID: ''
			}
		},
		props: ['incusent', 'inAmount'],
		methods: {
			payByAli() {
				if (this.Amount <= 0)
					return;
				ordercus.ProOrderCusPay(this.cusent.corpid, this.cusent.id, this.Amount)
					.then(res1 => {
						let entgrp = JSON.parse(JSON.stringify(res1.data))
						if (entgrp.Flag == 'success') {
							this.OrderID = entgrp.Data;
							pay.PayOrderCusByAli(this.cusent.id, this.OrderID, this.Amount)
								.then(res => {
									let ent = JSON.parse(JSON.stringify(res.data))
									if (ent.Flag == 'success') {
										this.doHtml(ent.Data);
										//this.IsPaySuccess();
									} else
										this.$message.info(ent.Msg);
								})
						} else
							this.$message.info('支付失败，请刷新重试！');
					});


			},
			payByWX() {

			},
			IsPaySuccess() {
				ordercus.GetCusOrderPayByCusID(this.cusent.id,'0')//待支付
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								let list = JSON.parse(ent.Data);
								for (let i = 0; i < list.length; i++) {
									if (list[i].order_price == this.Amount) {
										this.OrderID = list[i].ordid;
										this.checkPay();
										break;

									}
								}
							}
						}
					})


			},
			checkPay() {
				pay.QueryByAli(this.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$emit('payok')
							this.dopay();

						}
					})
			},
			dopay() {
				ordercus.OrderCusPay(this.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							
							//去预约
							// var data = {
							// 	path: '/SelBookBranch',
							// 	query: {
							// 		ent: JSON.stringify(this.cusent)
							// 	}
							// };
							// this.$router.push(data)
						}
					});
			},
			doHtml(formhtml) {
				let divForm = document.getElementsByTagName('divform')
				if (divForm.length) {
					document.body.removeChild(divForm[0])
				}
				const div = document.createElement('divform')
				div.innerHTML = formhtml // res.data就是sb支付宝返回给你的form
				document.body.appendChild(div)
				// document.forms[0].setAttribute('target', '_blank') // 加了_blank可能出问题所以我注释了
				document.forms[0].submit();
			}
		}
	}
</script>

<style>
</style>
